import React, { useState, useEffect } from 'react';
import PhoenixDocCard from 'components/base/PhoenixDocCard';
import CampaignAssignmentForm2 from 'components/forms/CampaignAssignmentForm2';
import CampaignAssignmentForm from 'components/forms/CampaignAssignmentForm';
import { Col, Row } from 'react-bootstrap';
import pass from 'assets/img/spot-illustrations/pass.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightLeft } from '@fortawesome/free-solid-svg-icons';

const CampaignAssigment = () => {
  const [showFirstForm, setShowFirstForm] = useState(true);
  const [bounce, setBounce] = useState(true);

  useEffect(() => {
    const toggleBounce = () => {
      setBounce(true);
      setTimeout(() => {
        setBounce(false);
      }, 5000); // Desactivar bounce después de 5 segundos
    };

    toggleBounce(); // Inicialmente activar bounce
    const intervalId = setInterval(toggleBounce, 15000); // Repetir ciclo cada 15 segundos

    return () => clearInterval(intervalId); // Limpiar intervalo al desmontar el componente
  }, []);

  const toggleForm = () => {
    setShowFirstForm(prevShowFirstForm => !prevShowFirstForm);
  };

  return (
    <div>
      <h2 className="mb-4 lh-sm">Campaign Access Management</h2>
      <PhoenixDocCard>
        <PhoenixDocCard.Header noPreview className="pb-1 pt-1">
          <Row>
            <Col className="d-flex justify-content-between align-items-center">
              <div>
                <h4 className="mb-2">Grant User Access to Campaigns</h4>
                <p className="mb-0">
                  To grant a user access to a campaign, you need to first
                  explicitly assign them the necessary permissions. This process
                  ensures that only authorized users can access specific
                  campaigns.
                  <br />
                  <br />
                  Please note that users with the
                  <span className="text-primary"> "systemadmin"</span> role
                  automatically have access to all services and campaigns by
                  default, and do not require additional permissions. These
                  users are excluded from the users list.
                </p>
              </div>
            </Col>
            <Col xs="auto" className="order-xxl-2">
              <div className="x-6">
                <img src={pass} alt="" />
              </div>
            </Col>
          </Row>
        </PhoenixDocCard.Header>
        <PhoenixDocCard.Body className="pt-0">
          <Row className="pb-2 text-center">
            <Col className="d-flex flex-column align-items-center">
              <span
                className="text-primary"
                onClick={toggleForm}
                style={{ cursor: 'pointer' }}
              >
                <FontAwesomeIcon
                  icon={faRightLeft}
                  className="me-5 fs-8"
                  bounce={bounce}
                />
              </span>
            </Col>
          </Row>
          <Row className="col-md-12">
            <div className="card card-container border border-0">
              <div className="form-group pb-6 align-items-end">
                {showFirstForm ? (
                  <CampaignAssignmentForm />
                ) : (
                  <CampaignAssignmentForm2 />
                )}
              </div>
            </div>
          </Row>
        </PhoenixDocCard.Body>
      </PhoenixDocCard>
    </div>
  );
};

export default CampaignAssigment;
